__turbopack_context__.v({
  "Container": "Container-module-scss-module__4-yW6G__Container",
  "Large": "Container-module-scss-module__4-yW6G__Large",
  "Small": "Container-module-scss-module__4-yW6G__Small",
  "XSmall": "Container-module-scss-module__4-yW6G__XSmall",
});
